import React from 'react';

function NumOfPager({ numPages, selected }) {
  if(numPages <= 1) return null;
  return (
    <span>
      {selected + 1} of {numPages}
    </span>
  );
}

export default NumOfPager;



// WEBPACK FOOTER //
// ./src/parts/NumOfPager.js